export const LAWYER_PLANS = {
  estate_setup: {
    name: "Estate Setup",
    sources: null,
    description:
      "Source-linked record, guided client intake, and estate details organized for your review",
    reviewDescription:
      "Elayne guides {name} through intake and builds a source-linked estate record, with documents, estate details, and next steps organized for your review",
    price: 500,
    firstClientPrice: 0,
    features: [
      "Shared attorney-client portal, so documents and details stay organized",
      "25+ client admin tasks handled, so follow-up never reaches your staff",
      "Names, dates, and values pulled from documents and cross-checked",
    ],
    savingsNote: "Save 10+ hours of non-billable work",
  },
  asset_discovery: {
    name: "Asset Search",
    sources: "IRS · Equifax",
    description:
      "IRS-authorized discovery across 100+ government and financial sources, plus debts, insurance, property, and source-linked findings",
    reviewDescription:
      "Elayne guides {name} through intake, then runs IRS-authorized discovery to surface missing accounts, debts, and policies before you file, not after",
    price: 3000,
    firstClientPrice: 0,
    features: [
      "Shared attorney-client portal, so documents and details stay organized",
      "25+ client admin tasks handled, so follow-up never reaches your staff",
      "Names, dates, and values pulled from documents and cross-checked",
    ],
    savingsNote: "$5M+ found for clients",
  },
  estate_administration: {
    name: "Estate Settlement",
    sources: null,
    description:
      "Transfer next steps, date-of-death values, beneficiary confirmations, EIN application, and estate account monitoring",
    reviewDescription:
      "Elayne guides {name} through intake, then prepares each transfer, documents date-of-death values, and secures the EIN, while you watch the estate account from your dashboard",
    price: 6000,
    firstClientPrice: 3000,
    features: [
      "Shared attorney-client portal, so documents and details stay organized",
      "25+ client admin tasks handled, so follow-up never reaches your staff",
      "Names, dates, and values pulled from documents and cross-checked",
    ],
    savingsNote: "Give your firm visibility throughout administration",
  },
} as const;

export type LawyerPlanKey = keyof typeof LAWYER_PLANS;
